export const API_URL = "https://v3-api.zarsangold.com";


// if showNumSix be false you must set defaultRingSize 4 otherwise defaultRingSize must be 5
export const showNumSix= false;
export const defaultRingSize = 4;
export const reverseShowNums = true;
